// Initial states used in Redux

import {
  liftFaultsColumns,
  apmFaultsColumns,
  driveFaultsColumns,
  groupFaultsColumns,
  networkFaultsColumns,
  monitoringFaultsColumns,
  monitoringFaultCategoriesColumns,
  nonKoneFaultsColumns,
  escalatorFaultsColumns,
  doorFaultsColumns,
  signalizationFaultsColumns
} from "./faultTableConfig";

import {
  liftParametersColumns,
  apmParametersColumns,
  driveParametersColumns,
  groupParametersColumns,
  safetyParametersColumns,
  escalatorParametersColumns,
  doorParametersColumns
} from "./parameterTableConfig";

import { driveSignalColumns, driveSignalGroupColumns, driveTestColumns } from "./driveTableConfig";
import { escalatorRTDColumns, escalatorRTDGroupColumns, escalatorDataActCodeColumns, escalatorEventLogColumns } from "./escalatorTableConfig";

import {
  faultComponentsColumns,
  domainsColumns,
  grandNormsColumns,
  parameterCategoriesColumns,
  enumerationsColumns,
  enumerationItemsColumns,
  languagesColumns,
  translationLogColumns,
  publishedFilesLocalesColumns,
  publishedFilesColumns
} from "./enumerationsTableConfig";

import { versionColumns, productColumns, doorVersionColumns } from "./VPTableConfig";
import { driveVersionColumns } from "./driveVersionTableConfig";
import { escalatorVersionColumns } from "./escalatorVersionTableConfig";
import { userColumns, AADGroupColumns } from "./userTableConfig";
import {
  liftEventEnumColumns,
  electrificationColumns,
  messageTypeColumns,
  messageTypeEventTypeColumns,
  messageTypeEventTypeColumnsWithRemove,
  ioBoardTypeColumns,
  ioCpuColumns,
  ioNetworkColumns,
  ioDatatypeColumns,
  ioOptionColumns,
  ioBasicDataTypeColumns,
  ioDataSectionColumns,
  ioDataSectionColumnsWithRemove,
  ioDataSectionColumnsSelect,
  IoOptionsEnumTypeColumns,
  DataActCodeColumns
} from "./liftEnumerationsConfig";
import { ioConfigurationColumns, standardBoardColumns } from "./IoConfigConfig";
import {
  driveSignalGroupLocalizationStatusColumns,
  driveSignalLocalizationStatusColumns,
  enumerationLocalizationStatusColumns,
  faultLocalizationStatusColumns,
  parameterLocalizationStatusColumns,
  escalatorRTDGroupLocalizationStatusColumns,
  escalatorRTDLocalizationStatusColumns,
  faultCategoryLocalizationStatusColumns,
  escalatorEventLogLocalizationStatusColumns
} from "./localizationStatusTableConfig";
import { commonEnumColumns, eventTypeEnumColumns } from "./doorEnumerationsConfig";
import { licenseUploadInitialState } from "./licenseUploadReducer";

export const pdApiInitialState: State.PdApi = {
  domainGroups: [],
  domains: [],
  features: [],
  faults: [],
  escalatorFaults: [],
  doorFaults: [],
  nonKoneFaults: [],
  liftParameters: [],
  driveParameters: undefined,
  groupParameters: [],
  apmParameters: undefined,
  safetyParameters: [],
  escalatorParameters: [],
  doorParameters: [],
  faultPriorities: [],
  parameterCategories: [],
  faultCategories: [],
  monitoringFaultCategories: undefined,
  monitoringFaults: undefined,
  roles: [],
  userGroups: [],
  users: [],
  enumerationGroups: [],
  faultComponents: [],
  kceVersions: {},
  kceProducts: {},
  driveVersions: {},
  signals: [],
  driveTests: [],
  signalGroups: [],
  escalatorRTDs: [],
  escalatorRTDGroups: [],
  eventTypes: [],
  eventClasses: [],
  eventPids: [],
  extCommands: [],
  messageTypes: [],
  ioBoardTypes: [],
  ioBasicDataTypes: [],
  iodataSections: [],
  ioCpuEnums: [],
  ioDataTypes: [],
  ioNetworks: [],
  ioOptions: [],
  ioOptionsEnumType: [],
  enumerations: [],
  enumerationItems: [],
  decks: [],
  sides: [],
  electrifications: [],
  aadgroups: [],
  locales: [],
  translationLogItems: [],
  chartData: {
    languageCoverage: [],
    itemTypeLanguageCoverage: [],
    translationSummary: []
  },
  doorEventClasses: [],
  doorEventTypes: [],
  doorEventPids: [],
  doorExtCommands: [],
  EscalatorEventClasses: undefined,
  EscalatorEventTypes: undefined,
  EscalatorEventPids: undefined,
  EscalatorExtCommands: undefined,
  EscalatorRequestTypes: undefined,
  DoorVersions: undefined,
  apmFaults: undefined,
  signalizationFaults: undefined,
  EscalatorVersions: {}, //object with Id as key and full version object as value
  driveFaults: undefined,
  liftFaults: undefined,
  groupFaults: undefined,
  networkFaults: undefined,
  dataActCodes: undefined,
  escalatorDataActCodes: undefined,
  grandNorms: undefined,
  escalatorEventLogs: []
};

export const mainInitialState: State.Main = {
  fetchingStatus: undefined,
  activeSubmenu: "Home",
  activeUser: undefined,
  editSize: 0.3,
  pageSize: 20,
  isShortenTextEnabled: true,
  lastEditedObjectId: undefined,
  lastSelectedParentObjectId: undefined
};

export const VPInitialState: State.VPView = {
  versionColumns,
  productColumns
};

export const enumerationsInitialState: State.EnumerationsView = {
  domainsColumns
};

export const editInitialState: State.EditView = {
  editedObject: undefined,
  storedObject: undefined,
  editedObjectCollection: undefined,
  storedObjectCollection: undefined,
  parentObject: undefined,
  editedObjectType: "",
  clipboard: undefined,
  hasEdited: undefined
};

export const toggleChildInitialState: State.ToggleChildView = {
  isChildOpen: false
};

export const columnsInitialState: State.ColumnMap = {
  "Elevator Faults": liftFaultsColumns,
  "APM Faults": apmFaultsColumns,
  "Drive Faults": driveFaultsColumns,
  "Group Faults": groupFaultsColumns,
  "Network Faults": networkFaultsColumns,
  "Monitoring Faults": monitoringFaultsColumns,
  "Monitoring Fault Categories": monitoringFaultCategoriesColumns,
  "Elevator Parameters": liftParametersColumns,
  "APM Parameters": apmParametersColumns,
  "Drive Parameters": driveParametersColumns,
  "Group Parameters": groupParametersColumns,
  "Safety Parameters": safetyParametersColumns,
  "Escalator Parameters": escalatorParametersColumns,
  "Escalator Faults": escalatorFaultsColumns,
  "Door Parameters": doorParametersColumns,
  "Door Faults": doorFaultsColumns,
  "NonKone Faults": nonKoneFaultsColumns,
  "Signalization Faults": signalizationFaultsColumns,
  Products: productColumns,
  Versions: versionColumns,
  "Fault Components": faultComponentsColumns,
  Domains: domainsColumns,
  "Grand Norm": grandNormsColumns,
  "Parameter Categories": parameterCategoriesColumns,
  "Drive Versions": driveVersionColumns,
  "Drive Signals": driveSignalColumns,
  "Drive Tests": driveTestColumns,
  "Drive Signal Groups": driveSignalGroupColumns,
  "Escalator RTDs": escalatorRTDColumns,
  "Escalator RTD Groups": escalatorRTDGroupColumns,
  Users: userColumns,
  "Event Classes": liftEventEnumColumns,
  "Event Pids": liftEventEnumColumns,
  "Event Types": liftEventEnumColumns,
  "Message Types": messageTypeColumns,
  "Message Type Event Types": messageTypeEventTypeColumns,
  "Message Type Event Types With Remove": messageTypeEventTypeColumnsWithRemove,
  "Ext. Commands": liftEventEnumColumns,
  "IO Basic Data Types": ioBasicDataTypeColumns,
  "IO Data Sections": ioDataSectionColumns,
  "IO Data Sections With Remove": ioDataSectionColumnsWithRemove,
  "IO Data Sections Select": ioDataSectionColumnsSelect,
  "IO Board Types": ioBoardTypeColumns,
  "IO CPUs": ioCpuColumns,
  "IO Datatypes": ioDatatypeColumns,
  "IO Networks": ioNetworkColumns,
  "IO Options": ioOptionColumns,
  "IO Configurations": ioConfigurationColumns,
  "IO Options Enum Type": IoOptionsEnumTypeColumns,
  "Standard Boards": standardBoardColumns,
  Electrifications: electrificationColumns,
  AADGroups: AADGroupColumns,
  "Common Enumerations": enumerationsColumns,
  "Common Enumeration Items": enumerationItemsColumns,
  "Published Files Locales": publishedFilesLocalesColumns,
  "Published Files": publishedFilesColumns,
  "Translation Log": translationLogColumns,
  "Enumeration Localization Status": enumerationLocalizationStatusColumns,
  "Parameter Localization Status": parameterLocalizationStatusColumns,
  "Fault Localization Status": faultLocalizationStatusColumns,
  "Drive Signal Localization Status": driveSignalLocalizationStatusColumns,
  "Drive Signal Group Localization Status": driveSignalGroupLocalizationStatusColumns,
  "Drive Test Localization Status": driveSignalLocalizationStatusColumns,
  "Escalator RTD Localization Status": escalatorRTDLocalizationStatusColumns,
  "Escalator RTD Group Localization Status": escalatorRTDGroupLocalizationStatusColumns,
  "Escalator Event Log Localization Status": escalatorEventLogLocalizationStatusColumns,
  "Fault Category Localization Status": faultCategoryLocalizationStatusColumns,
  Languages: languagesColumns,
  "Door Event Classes": commonEnumColumns,
  "Door Event Types": eventTypeEnumColumns,
  "Door Event Pids": commonEnumColumns,
  "Door Ext. Commands": commonEnumColumns,
  "Door Versions": doorVersionColumns,
  "Escalator Event Classes": commonEnumColumns,
  "Escalator Event Types": eventTypeEnumColumns,
  "Escalator Event Pids": commonEnumColumns,
  "Escalator Ext. Commands": commonEnumColumns,
  "Escalator Request Types": commonEnumColumns,
  "Escalator Versions": escalatorVersionColumns,
  "Data Act": DataActCodeColumns,  
  "Data Acts": escalatorDataActCodeColumns,
  "Event Logs": escalatorEventLogColumns,
};
export const ioConfigInitialState: State.IoConfig = {
  ioConfigFileText: undefined,
  selectedIoConfiguration: undefined,
  standardBoards: [],
  standardPoints: [],
  localFetchingStatus: undefined,
  selectedStandardBoard: {
    standardBoardId: undefined,
    standardNodeId: undefined,
    standardPointId: undefined,
    standardActionId: undefined
  },
  selectedIoBoard: {
    ioBoardId: undefined,
    ioNodeId: undefined,
    ioPointId: undefined,
    ioActionId: undefined
  },
  openedRows: {
    standardBoardTypes: [],
    standardBoards: [],
    ioBoardTypes: [],
    ioBoards: [],
    ioRevisions: []
  },
  ioConfigurations: [],
  ioBoards: [],
  ioBoardsGrouped: [],
  ionodePoints: []
};
export const isLoadingInitialState: State.LoadingStatus = {
  isLoadingParameters: false,
  isLoadingFaults: false,
  isLoadingStatistics: false,
  isLoadingEscalatorParameters: false,
  isLoadingEscalatorFaults: false,
  isLoadingTranslationLog: false,
  isLoadingApmParameters: false,
  isLoadingEventEnumerations: false,
  isLoadingDoorBindings: false,
  isLoadingEscalatorVersions: false,
  isLoadingApmFaults: false,
  isLoadingSignalizationFaults: false,
  isLoadingEscalatorRTDs: false,
  isLoadingEscalatorRTDGroups: false,
  isDriveFaultsLoading: false,
  isGroupFaultsLoading: false,
  isNetworkFaultsLoading: false,
  isMonitoringFaultsLoading: false,
  isMonitoringFaultCategoriesLoading: false,
  isLiftFaultsLoading: false,
  isDriveParametersLoading: false,
  isDataActCodesLoading: false,
  isEscalatorDataActCodesLoading: false,
  isGrandNormsLoading: false,
  isLoadingEscalatorEventLogs: false
};

export const isPublishingInitialState: State.PublishingStatus = {
  isPublishingLocalizations: false,
  lastLocalizationPublishCompletedAt: 0
};

export const isEscalatorDevPackageInitialState: State.EscalatorDevPackageStatus = {
  isDownloadingEscalatorDevPackage: false
};

export const isGeneratingLicenseInitialState: State.LicenseGenerationStatus = {
  isGeneratingLicense: false
};

export const filterOptionsInitialState: State.FilterOptions = {
  selectedKceVersion: -1,
  selectedKceProduct: -1,
  selectedDriveVersion: -1,
  selectedApmProduct: -1,
  selectedApmVersion: -1,
  selectedUserGroup: -1,
  selectedEscalatorVersion: -1,
  selectedEscalatorUserGroup: -1,
  selectedDoorVersion: -1,
  selectedDoorUserGroup: -1
};
export const translationStatusFilterOptionsInitialState: State.TranslationStatusFilterOptions = {
  selectedDomainGroupEnumValue: -1,
  selectedItemTypeId: 0,
  selectedDomainEnumValue: -1
};
export const initialState: State.Root = {
  pdApi: pdApiInitialState,
  editView: editInitialState,
  toggleChildView: toggleChildInitialState,
  main: mainInitialState,
  notifications: [],
  columns: columnsInitialState,
  ioConfig: ioConfigInitialState,
  loadingStatus: isLoadingInitialState,
  publishingStatus: isPublishingInitialState,
  licenseGenerationStatus: isGeneratingLicenseInitialState,
  licenseUploadStatus: licenseUploadInitialState,
  filterOptions: filterOptionsInitialState,
  translationStatusFilterOptions: translationStatusFilterOptionsInitialState,
  escalatorDevPackageStatus: isEscalatorDevPackageInitialState
};
